import React, { useState } from "react";
import { useAuth } from "component/UseAuth";
import { showError } from "component/utils/SweetAlert";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";


function Global({ onDownload, onLoading }) {
  const { user } = useAuth();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!startDate || !endDate ) {
      showError("Harap lengkapi semua input sebelum download.");
      return;
    }

    onDownload({ startDate, endDate });
  };

  return (
    <>
      <div className="row px-4 mt-3">
        <div className="card shadow mb-4">
          <div className="card-body">
            <h6 className="mb-3">Global</h6>

            <form onSubmit={handleSubmit}>
                <div className="row mb-2 align-items-center">
                    {/* Label dan Input Dari Tanggal */}
                    <label className="col-sm-2 form-label">Dari Tanggal</label>
                    <div className="col-sm-3">
                        <div className="input-group">
                            <span className="input-group-text">
                                <i className="bx bx-calendar"></i>
                            </span>
                            <Flatpickr
                                className="form-control form-control-sm "
                                value={startDate}
                                options={{
                                dateFormat: "Y-m-d",
                                // minDate: "today", // hanya bisa pilih mulai hari ini
                                }}
                                onChange={([date]) => {
                                setStartDate(date);
                                setEndDate(null); // reset endDate saat startDate berubah
                                }}
                            />
                        </div>
                    </div>

                    {/* Label s/d */}
                    <label className="col-sm-1 form-label text-center">s/d</label>

                    {/* Input Sampai Tanggal */}
                    <div className="col-sm-3">
                        <div className="input-group">
                            <span className="input-group-text">
                                <i className="bx bx-calendar"></i>
                            </span>
                            <Flatpickr
                                className="form-control form-control-sm "
                                value={endDate}
                                options={{
                                dateFormat: "Y-m-d",
                                minDate: startDate || "today", // tidak bisa sebelum startDate
                                }}
                                onChange={([date]) => setEndDate(date)}
                                disabled={!startDate} // tidak bisa diklik sebelum startDate diisi
                            />
                        </div>
                    </div>
                    <div className="col-sm-3">
                      <button type="submit" className="btn btn-success">
                        {onLoading ? "Loading..." : "Download PDF"}
                      </button>
                    </div>
                </div>
            </form>
          </div>
        </div>
      </div>

    </>
  );
}

export default Global;
